/*----------------------------------------------------

	autocomplete.js

----------------------------------------------------*/

var search_input = $('.js-autocomplete');
var search_query = '';
var threshold = 3;
var maxResults = 14;
var debounce = 250;
var results = [];
var ac_list = delay = '';

// -----------------------------------------------------------------------------------
// A. build autocomplete list
// -----------------------------------------------------------------------------------

function buildAutoCompleteList(){
  search_input.closest('form').append('<div class="autocomplete__results" data-docclose="hideAutocompleteCheck"></div>');
  ac_list = $('.autocomplete__results');
  ac_list.hide();
}


// -----------------------------------------------------------------------------------
// B. input listener
// -----------------------------------------------------------------------------------

function inputListener(){
  search_input.on('input', function(){

    clearTimeout(delay);

    search_query = $(this).val(); // search query

    if(search_query.length >= threshold){ // if over threshold do stuff
      delay = setTimeout(function(){
        getResults(search_query);
      },debounce);
    }else if(ac_list.is(':visible')){
      hideAutocomplete();
    }

  });
}


// -----------------------------------------------------------------------------------
// C. ajax result
// -----------------------------------------------------------------------------------

function getResults(search_query){

  // get results
  var source = '/include/autocomplete.php';
  $.ajax({
    url: source,
    type: 'get',
    dataType: 'json',
    data: {
      sq: search_query
    },
    success: function(data){
      if(data.length > 0){
        loadAutocompleteList(data);
      }else{
        hideAutocomplete();
      }
    },
    error: function(xhr){
      console.log('error');
    }
  });

}


// -----------------------------------------------------------------------------------
// D. load results
// -----------------------------------------------------------------------------------

function loadAutocompleteList(results){

  $(document).off('keydown');

  var autocomplete_output = '';
  i = 0;
  $.each(results, function(){
    if(i < maxResults){
      var label = this.label;
      var regex = new RegExp('('+search_query+')', 'ig');
      autocomplete_output += '<li><a href="' + this.href + '">' + label.replace(regex, '<span>$1</span>') + '</a></li>';
    }
    i++;
  });

  autocomplete_output = '<ul>' + autocomplete_output + '<li><a href="/shop/search.html?sq=' + search_query + '">All search results...</a></li>' + '</ul>';

  ac_list.html(autocomplete_output);
  ac_list.show();

  $(document).on('keydown',function(ev){
    autocompleteKeyboardNavigation(ev);
  });

}


// -----------------------------------------------------------------------------------
// E. hide autocomplete list 
// -----------------------------------------------------------------------------------

function hideAutocomplete(){
  ac_list.hide().find('ul').empty();
  $(document).off('keydown');
}

function hideAutocompleteCheck(ev){
  if(ac_list.is(':visible') && !$(ac_list).is(ev.target) && $(ac_list).has(ev.target).length === 0){
    hideAutocomplete();
  }
}

// window/document click event handled within generic showhide



// -----------------------------------------------------------------------------------
// F. keyboard navigation
// -----------------------------------------------------------------------------------

function autocompleteKeyboardNavigation(ev){
  switch(ev.which) {
    case 38: // up
      autocompleteMoveFocus('up')
    break;
    case 40: // down
      autocompleteMoveFocus('down')
    break;

    default: return;
  }
  ev.preventDefault();
}

function autocompleteMoveFocus(direction){

  var current_focus = $(document.activeElement);

  if($(current_focus).attr('id') == 'sq'){
    if(direction == 'down'){
      $(ac_list).find('li:first-child').find('a').focus();
    }else if(direction == 'up'){
      $(ac_list).find('li:last-child').find('a').focus();
    }
  }else{
    var current_focus_parent = $(current_focus).parent('li');
    if(($(current_focus_parent).is(':last-child') && direction == 'down') || ($(current_focus_parent).is(':first-child') && direction == 'up')){
      $(search_input).focus();
    }else{
      if(direction == 'down'){
        $(current_focus_parent).next().find('a').focus();
      }else if(direction == 'up'){
        $(current_focus_parent).prev().find('a').focus();
      }
    }

  }
}


// -----------------------------------------------------------------------------------
// X. init
// -----------------------------------------------------------------------------------

function autocomplete_init(){
  buildAutoCompleteList();
  inputListener();
}
autocomplete_init();